// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ExternalLinksObserver } from '@shared/commons/UtilsClasses/Observers/ExternalLinksObserver';
import { externalLinkManager } from '@shared/utils/Managers/ExternalLinkManager';
import { TerceraSideBarButton } from '../../elements/SideBar/TerceraSideBarButton';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
export class VideoWidgetButton extends TerceraSideBarButton {
    constructor() {
        super();
        this.tooltipKey = 'panel.VideoWidget';
        this._extLinksObserver = new ExternalLinksObserver();
        this.onUpdateExternalLinkEvent = () => {
            const ytLinks = externalLinkManager.getYoutubeLinks();
            const streamLink = ytLinks.find((tool) => tool.config.getStreamOnline());
            this.onLiveStreamOnAirChanged(streamLink !== undefined);
        };
    }
    getType() {
        return ControlsTypes.VideoWidgetButton;
    }
    oncomplete() {
        super.oncomplete();
        this._extLinksObserver.subscribeToAdd(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.subscribeToUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.subscribeToRemove(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.subscribeToYtUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.run();
    }
    onteardown() {
        this._extLinksObserver.unsubscribeToAdd(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.unsubscribeToUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.unsubscribeToRemove(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.unsubscribeToYtUpdate(this.onUpdateExternalLinkEvent);
        this._extLinksObserver.stop();
    }
    onLiveStreamOnAirChanged(value) {
        void this.set({ svgStyle: value ? 'videoWidgetBtnLive' : 'videoWidgetBtn' });
    }
}
TerceraSideBarButton.extendWith(VideoWidgetButton, {
    data: function () {
        return {
            text: '',
            liveStreamOnAir: false, // If there are live streams now, then the button will have a different text and view: js-button-video-widget.live
            svgStyle: 'videoWidgetBtn'
        };
    }
});
